import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MODAL_DATA, MODAL_REF, ModalRef } from '@services/components/ModalService/modal.ref';

export interface GenericConfirmModalData {
  message: string;
  cancelButtonLabel?: string;
  primaryButtonLabel?: string;
}

@Component({
  selector: 'app-generic-confirm-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="generic-confirm-modal">
      <p class="generic-confirm-modal__description">
        {{ message }}
      </p>
      <div class="generic-confirm-modal__actions">
        <button
          class="btn btn-secondary"
          type="button"
          (click)="onCancel()">
          {{ cancelLabel }}
        </button>
        <button
          class="btn btn-primary"
          type="button"
          (click)="onConfirm()">
          {{ primaryLabel }}
        </button>
      </div>
    </div>
  `,
  styles: [`
    .generic-confirm-modal__description {
      font-family: 'Space Mono', monospace;
      font-size: 0.875rem;
      color: var(--text-dark);
      margin: 0 0 1.5rem;
      line-height: 1.6;
    }

    .generic-confirm-modal__actions {
      display: flex;
      justify-content: flex-end;
      gap: 0.75rem;
    }

    .btn {
      padding: 0.6rem 1.4rem;
      font-family: 'Space Mono', monospace;
      font-size: 0.875rem;
      font-weight: 700;
      border: 2px solid var(--text-dark);
      cursor: pointer;
      transition: transform 0.15s ease, box-shadow 0.15s ease;
    }

    .btn:hover {
      transform: translate(-2px, -2px);
      box-shadow: 4px 4px 0 var(--text-dark);
    }

    .btn-primary {
      background-color: var(--accent-red);
      color: #ffffff;
    }

    .btn-secondary {
      background-color: transparent;
      color: var(--text-dark);
    }
  `],
})
export class GenericConfirmModalComponent {
  private readonly modalRef = inject(MODAL_REF) as ModalRef<boolean>;
  private readonly data = inject<GenericConfirmModalData>(MODAL_DATA);

  public readonly message = this.data?.message ?? '';
  public readonly cancelLabel = this.data?.cancelButtonLabel ?? 'Volver';
  public readonly primaryLabel = this.data?.primaryButtonLabel ?? 'Aceptar';

  public onConfirm(): void {
    this.modalRef.close({ reason: 'confirm', data: true });
  }

  public onCancel(): void {
    this.modalRef.close({ reason: 'cancel', data: false });
  }
}
